import { toast } from "react-toastify";
import { deleteItems, updateStateData } from "../Store/actions";
import store from "../Store/store";
import { sendApiRequest } from "./requestConfig";
import { validateAlphabets, validateAlphanumeric, validateInputLength } from "./utils";

// to check the available report sections wrt workspace and also the selected settings for a particular campaign
export const fetchReportFilters = async () => {
    // call api
    const fetchFilters = await sendApiRequest("reports/filters", "", "GET");
    
    //   evaluate api response
    if (typeof fetchFilters.success !== "undefined" && fetchFilters.success === true) {

        store.dispatch(
            updateStateData({
                workspace_report_filters: fetchFilters.response,
            })
        );
        return {
            success: true,
        };
    } else {
        return {
            success: false,
        };
    }
};

export const validateNewWorkspaceSection = (sectionType) => {
    const userStateData = store.getState().userSelections;
    let error = false;
    let errorDetails = {};
    // section id (If editing)
    const sectionId = typeof userStateData.workspace_section_selections !== "undefined" && typeof userStateData.workspace_section_selections.section_id !== "undefined" ? userStateData.workspace_section_selections.section_id : "";
    // section name
    const sectionName = typeof userStateData.workspace_section_selections !== "undefined" && typeof userStateData.workspace_section_selections.section_name !== "undefined" ? userStateData.workspace_section_selections.section_name : "";
    // embeddable section id
    const embeddableId = typeof userStateData.workspace_section_selections !== "undefined" && typeof userStateData.workspace_section_selections.embeddable_section_id !== "undefined" ? userStateData.workspace_section_selections.embeddable_section_id : "";
    // section description
    const sectionDesc = typeof userStateData.workspace_section_selections !== "undefined" && typeof userStateData.workspace_section_selections.section_description !== "undefined" ? userStateData.workspace_section_selections.section_description : "";

    const filterSelection = typeof userStateData.workspace_filter_selections !== "undefined" ? userStateData.workspace_filter_selections : [];

    // validation checks
    const validateSectionName = validateAlphanumeric(sectionName, false);
    const validateSectionDesc = { error: false };

    const validateEmbeddableId = validateAlphanumeric(embeddableId, true);

    if (validateSectionName.error === true) {
        error = true;
        errorDetails = {
            ...errorDetails,
            section_name: "Section Name must not be empty and may not contain special characters",
        };
    }

    if (validateEmbeddableId.error === true) {
        error = true;
        errorDetails = {
            ...errorDetails,
            embeddable_section_id: "Embeddable ID must not be empty and may only contain letter, number, and hyphens",
        };
    }

    if (validateSectionDesc.error === true) {
        error = true;
        errorDetails = {
            ...errorDetails,
            section_description: "", //Error should be posible anymore because the field is optional and Character constrainst has been removed
        };
    }

    if (error === true) {
        return {
            error: true,
            error_messages: { ...errorDetails },
        };
    } else {
        let requestData = {
            "name": sectionName,
            "id_embeddable": embeddableId,
            "id_filters": filterSelection,
            "type": sectionType,
            "description": sectionDesc
        }

        if (sectionId !== "") {
            requestData = {
                ...requestData,
                "id": sectionId
            }
        }

        return {
            error: false,
            request_data: requestData
        }
    }
};

export const resetNewSectionDetails = () => {
    store.dispatch(deleteItems(["workspace_section_selections", "workspace_filter_selections"]));
};

export const fetchWorkspaceSections = async () => {
    // call api
    const fetchSections = await sendApiRequest("reports/sections", "", "GET");
    //   evaluate api response
    if (typeof fetchSections.success !== "undefined" && fetchSections.success === true) {
        store.dispatch(
            updateStateData({
                workspace_report_sections: fetchSections.response,
            })
        );
        return {
            success: true,
        };
    }
    else {
        return {
            success: false,
        };
    }
};

// to save new section for the reports
export const saveNewSectionForWorkspace = async (sectionType, usedFor) => {
    // validate data
    const validateData = validateNewWorkspaceSection(sectionType);
    if (validateData.error === true) {
        toast("Please check the errors.", { type: "error" });
        return validateData;
    } else {
        // call api
        const apiEndpoint = usedFor === "add" ? "reports/sections/add" : "reports/sections/update";
        const saveSection = await sendApiRequest(apiEndpoint, validateData.request_data, "POST");
        //   evaluate api response
        if (typeof saveSection.success !== "undefined" && saveSection.success === true) {
            resetNewSectionDetails();
            await fetchWorkspaceSections();
            toast("New section saved successfully", { type: "success" });
            return {
                success: true,
            };
        } else {
            toast("Sorry, something went wrong.", { type: "error" });
            return {
                success: false,
            };
        }
    }

};

// archive section
export const archiveWorkspaceSection = async (sectionId) => {
    // call api
    const archiveSections = await sendApiRequest("reports/sections/archive/" + sectionId,
        {
            "archived": true
        },
        "POST");
    //   evaluate api response
    if (typeof archiveSections.success !== "undefined" && archiveSections.success === true) {
        await fetchWorkspaceSections();
        toast("Section archived successfully", { type: "success" });
        return {
            success: true,
        };
    }
    else {
        return {
            success: false,
        };
    }
}

export const recoverWorkspaceSection = async (sectionId) => {
    // call api
    const recoverSections = await sendApiRequest("reports/sections/archive/" + sectionId,
        {
            "archived": false
        },
        "POST");
    //   evaluate api response
    if (typeof recoverSections.success !== "undefined" && recoverSections.success === true) {
        await fetchWorkspaceSections();
        toast("Section recovered successfully", { type: "success" });
        return {
            success: true,
        };
    }
    else {
        return {
            success: false,
        };
    }
}

export const deleteWorkspaceSection = async (sectionId) => {
    // call api
    const deleteSections = await sendApiRequest(
        "reports/sections/delete/" + sectionId,
        {},
        "POST"
    );
    //   evaluate api response
    if (typeof deleteSections.success !== "undefined" && deleteSections.success === true) {
        await fetchWorkspaceSections();
        toast("Section deleted successfully", { type: "success" });
        return {
            success: true,
        };
    }
    else {
        return {
            success: false,
        };
    }
}